module.exports = __webpack_public_path__ + "static/media/active.71c3d5d5.svg";